import { motion } from "framer-motion";
import { Plus, Check } from "lucide-react";
import { euro, imgSrc } from "@/lib/api";

export const ExtraCard = ({ entry, product, added, skinName, onAdd, onRemove, onAlternatives }) => {
  const info = entry.extra_info?.[product.id] || { frequency: entry.frequency, how: entry.how_to_insert };
  const reasons = product.matched_labels || [];
  return (
    <motion.article initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
      className="my-6 p-6 sm:p-8 bg-[#FBF3E3] border border-[#C5A059] grid sm:grid-cols-12 gap-6 sm:gap-10" data-testid="routine-extra-exfoliate">
      <div className="sm:col-span-12 flex items-baseline gap-4">
        <span className="font-serif italic text-[#8C6F3E] text-xl tracking-wide" data-testid="extra-label">Extra</span>
        <div>
          <p className="fs-eyebrow text-[#8C6F3E]">{entry.step_label} · {entry.step_name}</p>
          <p className="text-sm text-[#8C6F3E]/80 mt-1">{entry.step_description}</p>
        </div>
      </div>
      <div className="sm:col-span-4">
        <p className="inline-flex items-center text-[11px] tracking-[0.18em] uppercase text-[#FAF8F5] bg-[#8C6F3E] px-3 py-1.5 mb-3" data-testid="extra-frequency">{info.frequency}</p>
        <div className="aspect-[4/5] bg-white/60 overflow-hidden border border-[#EBD9B4]">
          {product.image && <img src={imgSrc(product.image)} alt={product.name} className="w-full h-full object-cover" />}
        </div>
      </div>
      <div className="sm:col-span-8">
        <p className="text-[11px] tracking-[0.2em] uppercase text-[#8C8275]">{product.brand}</p>
        <h3 data-testid="extra-product-name" className="font-serif text-2xl sm:text-3xl mt-2 leading-tight">{product.name}</h3>
        <p className="text-sm text-[#595652] mt-2 tabular-nums">{euro(product.price)}</p>
        <div className="mt-6">
          <p className="fs-eyebrow text-[#8C6F3E]">Perché è adatto a te</p>
          <p className="text-[15px] leading-relaxed text-[#1A1A18] mt-2 font-light">
            {skinName && <>Esfoliazione compatibile con la tua <em className="font-serif">{skinName.toLowerCase()}</em>{reasons.length ? <> e pensata per {reasons.join(", ").toLowerCase()}</> : null}. </>}
            {product.why_text}
          </p>
        </div>
        <div className="mt-5">
          <p className="fs-eyebrow text-[#8C6F3E]">Come inserirlo nella tua sera</p>
          <p className="text-sm leading-relaxed text-[#595652] mt-2" data-testid="extra-how">{info.how}</p>
        </div>
        <div className="mt-7 flex flex-wrap gap-6 items-center">
          {added ? (
            <button data-testid="extra-remove-btn" className="fs-btn-ghost inline-flex items-center gap-2" onClick={onRemove}><Check size={14} /> Nella tua routine · Rimuovi</button>
          ) : (
            <button data-testid="extra-add-btn" className="fs-btn !py-2.5 !px-5 inline-flex items-center gap-2" onClick={onAdd}><Plus size={14} /> Aggiungi alla routine</button>
          )}
          {entry.candidates.length > 1 && (
            <button data-testid="open-alternatives-exfoliate" className="fs-btn-ghost text-[#1A1A18] border-[#C5A059]" onClick={onAlternatives}>
              Alternative compatibili ({entry.candidates.length - 1})
            </button>
          )}
        </div>
      </div>
    </motion.article>
  );
};
